import React from 'react';
import ReactDOM from 'react-dom';
import App from './app/App';
import reportWebVitals from './reportWebVitals';

import { loadTheme } from '@fluentui/react';

loadTheme({
    palette: {
        themePrimary: '#6366f1',
        themeLighterAlt: '#1e1b4b',
        themeLighter: '#312e81',
        themeLight: '#4338ca',
        themeTertiary: '#6366f1',
        themeSecondary: '#818cf8',
        themeDarkAlt: '#4f46e5',
        themeDark: '#4338ca',
        themeDarker: '#3730a3',
        neutralLighterAlt: '#18181b',
        neutralLighter: '#27272a',
        neutralLight: '#3f3f46',
        neutralQuaternaryAlt: '#52525b',
        neutralQuaternary: '#71717a',
        neutralTertiaryAlt: '#a1a1aa',
        neutralTertiary: '#d4d4d8',
        neutralSecondary: '#e4e4e7',
        neutralPrimaryAlt: '#f4f4f5',
        neutralPrimary: '#fafafa',
        neutralDark: '#fafafa',
        black: '#fafafa',
        white: '#09090b',
    },
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
